import {
  SET_CHART_CONNECT_NULLS,
  SET_CHART_ENERGY_TYPE,
  SET_CHART_TYPE,
  SET_CHART_ZOOM_FETCH
} from '../constants/actionTypes';

const initialState = {
  chartType: 'line',
  syncYAxis: true,
  fetchOnSelect: true,
  connectNulls: true,
  activeEnergyTypes: ['power'],
  energyTypes: {
    power: {
      name: 'Power',
      active: true,
      unit: 'kW',
      opposite: false,
      syncYAxs: true,
      key: 'power'
    },
    apparent_power: {
      name: 'Apparent Power',
      unit: 'kVA',
      opposite: true,
      syncYAxs: true,
      key: 'apparent_power'
    },
    reactive_power: {
      name: 'Reactive Power',
      unit: 'kVAr',
      opposite: true,
      syncYAxs: true,
      key: 'reactive_power'
    },
    power_factor: {
      name: 'Power Factor',
      unit: '° Deg',
      opposite: true,
      syncYAxs: false,
      yAxisMax: 1,
      key: 'power_factor',
      alignTicks: true
    }
    /* signed_power: {
      name: 'Signed Power',
      unit: "kW",
      opposite: true,
      syncYAxs: false,
      yAxisMax: false,
      key: 'signed_power'
    } */
  }
};

const chartOptions = (state = initialState, action) => {
  switch (action.type) {
    case SET_CHART_TYPE:
      return { ...state, chartType: action.payload };
    case SET_CHART_ZOOM_FETCH:
      return { ...state, fetchOnSelect: action.payload };
    case SET_CHART_CONNECT_NULLS:
      return { ...state, connectNulls: action.payload };
    case SET_CHART_ENERGY_TYPE:
      const energyTypeKey = action.payload;
      if (state.activeEnergyTypes.includes(energyTypeKey)) {
        return {
          ...state,
          activeEnergyTypes: state.activeEnergyTypes.filter(
            type => type !== energyTypeKey
          )
        };
      }

      return {
        ...state,
        activeEnergyTypes: [...state.activeEnergyTypes, energyTypeKey]
      };
    default:
      return state;
  }
};

export default chartOptions;



// WEBPACK FOOTER //
// ./src/redux/chartOptions.js